import React, { useState } from "react";
import { Spinner } from "reactstrap";
import { Zap, Check } from "react-feather";
import toast from "react-hot-toast";
import xavaLogo from "../../assets/images/xava-logo.png";
import {
  useGetPendingAnnouncementsQuery,
  useAcknowledgeAnnouncementMutation,
} from "../../service";
import "./announcementGate.scss";

// Blocking "what's new" for the signed-in user. Shows one announcement at a
// time; if it requires acknowledgement, the Continue button stays disabled
// until the box is ticked. Acknowledgement is saved to the account, so it
// won't reappear on another device — and it's a real record that they read it.
function AnnouncementGate() {
  const { data, isLoading } = useGetPendingAnnouncementsQuery();
  const [acknowledge, resAck] = useAcknowledgeAnnouncementMutation();
  const [checked, setChecked] = useState(false);

  const pending = data?.data || [];
  if (isLoading || pending.length === 0) return null;

  const a = pending[0]; // one at a time; the next shows on the next render
  const needsAck = a.requireAck;

  const proceed = async () => {
    if (needsAck && !checked) return;
    try {
      await acknowledge({ key: a.key }).unwrap();
      setChecked(false); // reset for any next announcement
    } catch (e) {
      toast.error("Couldn't save that. Please try again");
    }
  };

  return (
    <div className="xv-announce" role="dialog" aria-modal="true" aria-label={a.title}>
      <div className="xv-announce-card">
        <div className="xv-announce-head">
          <span className="xv-announce-badge">
            <Zap size={16} /> What&apos;s new
          </span>
          <img src={xavaLogo} alt="Xava" className="xv-announce-logo" />
        </div>

        <h2>{a.title}</h2>
        {a.intro && <p className="xv-announce-intro">{a.intro}</p>}

        {Array.isArray(a.points) && (
          <ul className="xv-announce-points">
            {a.points.map((point, i) => (
              <li key={i}>
                <span className="xv-announce-tick">
                  <Check size={13} />
                </span>
                <span dangerouslySetInnerHTML={{ __html: point }} />
              </li>
            ))}
          </ul>
        )}

        {needsAck && (
          <label className="xv-announce-ack">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
            />
            <span>{a.ackLabel || "I have read and understood the above."}</span>
          </label>
        )}

        <button
          type="button"
          className="xv-announce-btn"
          disabled={(needsAck && !checked) || resAck.isLoading}
          onClick={proceed}
        >
          {resAck.isLoading ? <Spinner size="sm" /> : "Got it, take me in"}
        </button>
      </div>
    </div>
  );
}

export default AnnouncementGate;
